import { createFileRoute } from "@tanstack/react-router";
import { SpcSystemDiagramViewerPage } from "src/components/views/erp/common/systemDiagrams/viewer/SystemDiagramViewerPage.tsx";
import { SystemDiagramViewerApi } from "src/api/generated/systemDiagrams/viewer/systemDiagramViewerApi.ts";
import { useKeptAliveGeneratedView } from "src/routing/keepAlive/keptAliveView.ts";

export const Route = createFileRoute("/_authenticated/_shell/spc/systemDiagrams/$systemDiagramId")({
	staticData: {
		legacyViewKey: "spcSystemDiagramsPage",
		listGeneratedViews: async () =>
			(await SystemDiagramViewerApi.listSpc()).diagrams.map((diagram) => ({
				id: diagram.systemDiagramId,
				title: diagram.name,
			})),
	},
	component: RouteComponent,
});

function RouteComponent() {
	const {
		view: { generatedId: id },
	} = useKeptAliveGeneratedView();
	return <SpcSystemDiagramViewerPage systemDiagramId={id} />;
}
